<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Indikator" @back="back">
            
        </a-page-header>

        <a-row type="flex" style="margin-bottom: 12px">
            <a-col  style="padding-left: 12px" flex="1 1 200px">
                
            </a-col>
            <a-col flex="0 1 300px">
                <a-button type="primary" icon="plus" block @click="showModal('')">
                Tambah
                </a-button>
            </a-col>
        </a-row>

        <a-card type="inner" size="small" >
            <a-table
                class="pcp-table"
                :columns="columns"
                :dataSource="items.data"
                rowKey="hash"
                :loading="loading"
                :pagination="false"
                bordered>

                <div slot="module" slot-scope="record" class="text-small text-left">
                    {{ record.name }}
                </div>

                <div slot="short_code" slot-scope="record" class="text-small text-left">
                    {{ record.short_code }}
                </div>

                <div slot="code" slot-scope="record" class="text-small text-left">
                    {{ record.code }}
                </div>

                <div slot="type" slot-scope="record" class="text-small text-left">
                    {{ record.type }}
                </div>

                <div slot="name" slot-scope="record" class="text-small text-left">
                    {{ record.name }}
                </div>

                <div slot="updated_at" slot-scope="record" class="text-small text-center">
                    <template v-if="record.updated_at != null">
                        {{ moment(record.updated_at).format('DD-MM-YYYY HH:mm:ss') }}
                    </template>
                </div>

                <div slot="action" slot-scope="record" style="text-align: center">
                    <a-space>
                        <a-tooltip title="Detail">
                            <a-button size="small" icon="eye" :href="routeUri('admin.setting.branch') + '?id=' + record.hash" />
                        </a-tooltip>

                        <a-tooltip title="Edit">
                            <a-button size="small" type="primary" icon="edit" @click="showModal(record.hash)" />
                        </a-tooltip>
                    </a-space>
                </div>
            </a-table>
        </a-card>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visible"
            :closable="false"
        >
            <admin-setting-indicator-form
                :hash="hash"
                :perspective="perspective"
                @handleClose="closeModal"
            />
        </a-modal>
    </div>
</template>

<script>

const columns = [
    {
		key: 'module',
		title: 'Aspek',
        align: 'center',
		scopedSlots: {customRender: 'module'},
	}, {
		key: 'short_code',
		title: 'Short Code',
        align: 'center',
        width: '150px',
		scopedSlots: {customRender: 'short_code'},
	}, {
		key: 'code',
		title: 'Kode',
        align: 'center',
        width: '150px',
		scopedSlots: {customRender: 'code'},
	}, {
        key: 'updated_at',
        title: 'Last Update',
        align: 'center',
        width: '180px',
        scopedSlots: {customRender: 'updated_at'}
    }, 
]

export default {
    props: {
        perspective: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            columns,
            loading: false,
            items: {
                data: []
            },
            filters: {
                q: null,
                module: 'performance',
                type: 'indicator',
                parent: this.perspective
            },
            hash: null,
            visible: false,
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri('api.category'), {
                    params: this.filters
                })
                .then(response => this.items = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        showModal(hash) {
            this.hash = hash;
            this.visible = true;
        },
        closeModal(isRefresh) {
            this.visible = false;

            if (isRefresh == true) {
                this.getItems();
            }
        },
        back() {
            window.location.href = this.routeUri("admin.setting.perspective")
        }
    },
}
</script>
